import { Link, Popover } from '@mui/material';
import { Product } from '@thro-types/leihbar';

import { useState } from 'react';

import Logo from 'app/components/Logo';

import { BundleProductPopOver } from './BundleProductPopOver';

interface Props {
  product: Product;
}
export const BundleProduct = ({ product }: Props) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    handlePopoverOpen(event);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <Link
        onClick={handleClick}
        key={product.id}
        aria-owns={open ? 'mouse-over-popover' : undefined}
        aria-haspopup="true"
      >
        <Logo src={product.image} size={'small'} isS3={true} />
      </Link>
      <Popover
        id="mouse-over-popover"
        className="product-detail__leftSide__bundleItem"
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        onClose={handlePopoverClose}
        PaperProps={{
          style: { maxWidth: '40em' }
        }}
      >
        <BundleProductPopOver product={product} />
      </Popover>
    </>
  );
};
